import axios from 'axios'

import { PayrollPeriod } from '@/models'
import { PayrollPeriodResponseApiParams, transformApiParamsToPayrollPeriod } from '@/services/PayrollPeriodServices/PayrollPeriodService'

export const getPayrollPeriods = async (): Promise<PayrollPeriod[]> => {
    const response = await axios
        .get<PayrollPeriodResponseApiParams[]>(`${process.env.REACT_APP_API_URL}/payroll-periods`, {
            params: {
                orderByStart: JSON.stringify({ start: 'ASC' }),
            },
        })

    return response.data.map(
        (payrollPeriod: PayrollPeriodResponseApiParams) => transformApiParamsToPayrollPeriod(
            payrollPeriod,
        ),
    )
}
